import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import CurrencyInput from 'react-currency-input';
import ContactList from '../../components/contact-list-component';
import WorkflowStepBaseComponent from './workflow-step-base';
import InvoiceStore from '../../invoice/invoice-store';
import mobx, { autorun, transaction } from 'mobx';
import Notifications from '../../utils/notification-helper';
import moment from 'moment';
import S3DownloadButton from '../../components/s3-download-button';
import CreateInvoiceComponent from '../../components/create-invoice-component';
import StepActionButtons from './components/step-actions';
import StepHistory from '../../components/step-history';
import InvoiceFileModal from '../../files/invoice-form-modal';

@inject('appStore')
@observer
export default class CreateInvoiceStep extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
    }

    handleInvoiceCreated(invoice, fileData) {
        const step = this.props.step;
        step.state.isComplete = true;
        step.state.data.message = `Invoice Created: ${new moment().format('llll')}.`;
        step.state.data.invoiceFileData = fileData;
        step.state.data.invoice = invoice;
        step.state.data.invoiceContact = {
            email: invoice.billToEmail,
            name: invoice.attention,
            companyName: invoice.billTo,
        };
        this.updateStepState(step);
        this.forceUpdate()
    }

    renderIncompleteView() {
        const isMarkedNotApplicable = this.props.step.state.isMarkedNotApplicable;
        return (
            <div className="create-invoice">
                <StepActionButtons viewStore={this.viewStore} step={this.props.step} />
                <hr className="section-header" />
                {isMarkedNotApplicable ? null : (
                    <CreateInvoiceComponent handleInvoiceCreated={this.handleInvoiceCreated.bind(this)} />
                )}
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }

    renderCompleteView() {
        const data = this.props.step.state.data;
        const fileKey = data.invoiceFileData && data.invoiceFileData.fileKey ? data.invoiceFileData.fileKey : '';
        const filename = data.invoiceFileData && data.invoiceFileData.filename ? data.invoiceFileData.filename : '';

        return (
            <div>
                <span>{this.props.step.state.data.message}</span>
                {fileKey && filename ? (
                    <div className="create-invoice">
                        <S3DownloadButton bsStyle="link" fileKey={fileKey}>
                            {filename}
                        </S3DownloadButton>
                        <br/>
                        <button
                            type="button"
                            className="btn btn-default"
                            disabled={!this.props.step.state.isComplete}
                            onClick={appStore.viewStore.showInvoiceFileDialogModal}
                        >
                            Create New Invoice
                        </button>
                        <InvoiceFileModal handleInvoiceCreated={this.handleInvoiceCreated.bind(this)}/>
                    </div>
                ) : (
                    <span>
                        {' '}
                        <b>Attached file not properly linked.</b>
                    </span>
                )}
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/create-invoice-step.js